export const SET_OFFERS = 'SET_OFFERS';
export const SET_IS_FETCHING_OFFERS = 'SET_IS_FETCHING_OFFERS';
export const SET_IS_FETCHING_COUNTIES_AND_MARKETS =
  'SET_IS_FETCHING_COUNTIES_AND_MARKETS';
export const SET_IS_DOWNLOAD_OFFERS = 'SET_IS_DOWNLOAD_OFFERS';
export const SET_OFFER = 'SET_OFFER';
export const SET_CURRENT_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';

export const SET_APPLIED_FILTERS = 'SET_APPLIED_FILTERS';

export const SET_COUNTIES_AND_MARKETS = 'SET_COUNTIES_AND_MARKETS';

export const SET_PENDING_ACTIONS = 'SET_PENDING_ACTIONS';

export const SET_SELECTED_OFFER_FOR_CONTACT = 'SET_SELECTED_OFFER_FOR_CONTACT';
